import { ChevronIcon } from '@ardoq/icons';
import { GhostButton } from '@ardoq/button';
import { extendPaginationProps } from './utils';
import { noop } from 'lodash';
import { NumberVisualProperties, PaginationProps } from './types';
import { Ellipsis, Wrapper } from './atoms';

const DefaultNumberVisual = ({
  value,
  onClick,
  isActive,
}: NumberVisualProperties) => (
  <GhostButton isActive={isActive} onClick={onClick}>
    {value}
  </GhostButton>
);

export const Pagination = (props: PaginationProps) => {
  const {
    currentPageNumber,
    onPageSelect,
    isDisabled,
    NumberVisual = DefaultNumberVisual,
    previousPageAriaLabel = 'Previous page',
    nextPageAriaLabel = 'Next page',
  } = props;
  const pageSelect = onPageSelect || noop;
  const {
    hasNextPage,
    hasPrevPage,
    numbersToRender,
    totalNumberOfPages,
    showLastNumber,
    showFirstNumber,
    showMoreEllipsis,
    showLessEllipsis,
  } = extendPaginationProps(props);
  return (
    <Wrapper $isDisabled={isDisabled} style={props.style}>
      <GhostButton
        dataTestId="pagination-previous"
        aria-label={previousPageAriaLabel}
        isDisabled={!hasPrevPage}
        onClick={() => pageSelect(currentPageNumber - 1)}
      >
        <ChevronIcon direction="left" />
      </GhostButton>
      {showFirstNumber && (
        <GhostButton
          onClick={() => pageSelect(1)}
          dataTestId="pagination-indicator"
        >
          1
        </GhostButton>
      )}
      {showLessEllipsis && <Ellipsis />}
      {numbersToRender.map(numberToRender => (
        <NumberVisual
          key={numberToRender}
          value={numberToRender}
          isActive={currentPageNumber === numberToRender}
          onClick={() => pageSelect(numberToRender)}
        />
      ))}
      {showMoreEllipsis && <Ellipsis />}
      {showLastNumber && (
        <NumberVisual
          value={totalNumberOfPages}
          isActive={false}
          onClick={() => pageSelect(totalNumberOfPages)}
        />
      )}
      <GhostButton
        dataTestId="pagination-next"
        aria-label={nextPageAriaLabel}
        isDisabled={!hasNextPage}
        onClick={() => pageSelect(currentPageNumber + 1)}
      >
        <ChevronIcon direction="right" />
      </GhostButton>
    </Wrapper>
  );
};
